// extracted by mini-css-extract-plugin
export default {"dropdown":"LanguageSelector_dropdown__pZCMR","selected":"LanguageSelector_selected__hliAx","arrow":"LanguageSelector_arrow__veFF4","menu":"LanguageSelector_menu__hFXI5"};